export default [
  {
    path: '/diet',
    name: 'diet',
    component: () => import('@/views/menu/diet/diet.vue'),
    meta: {
      pageTitle: 'مدیریت رژیم غذا',
      action: 'show',
      resource: 'DietManager',
    },
  },
  {
    path: '/diet/details',
    name: 'adddiet',
    component: () => import('@/views/menu/diet/dietdetails.vue'),
    meta: {
      pageTitle: 'ایجاد رژیم غذا',
      action: 'show',
      resource: 'DietManager',
    },
  },
  {
    path: '/diet/details/:id',
    name: 'updatediet',
    component: () => import('@/views/menu/diet/dietdetails.vue'),
    meta: {
      pageTitle: 'ویرایش رژیم غذا',
      action: 'show',
      resource: 'DietManager',
    },
  },
  {
    path: '/dietduration',
    name: 'dietduration',
    component: () => import('@/views/menu/diet/dietduration.vue'),
    meta: {
      pageTitle: 'مدیریت دوره ها',
      action: 'show',
      resource: 'DietDurationManager',
    },
  },
  {
    path: '/dietduration/details',
    name: 'adddietduration',
    component: () => import('@/views/menu/diet/dietdurationdetails.vue'),
    meta: {
      pageTitle: 'ایجاد دوره',
      action: 'show',
      resource: 'DietDurationManager',
    },
  },
  {
    path: '/dietduration/details/:id',
    name: 'updatedietduration',
    component: () => import('@/views/menu/diet/dietdurationdetails.vue'),
    meta: {
      pageTitle: 'ویرایش دوره',
      action: 'show',
      resource: 'DietDurationManager',
    },
  },
  {
    path: '/dietdurationprice',
    name: 'dietdurationprice',
    component: () => import('@/views/menu/diet/dietdurationprice.vue'),
    meta: {
      pageTitle: 'مدیریت قیمت رژیم',
      action: 'show',
      resource: 'DietDurationPriceManager',
    },
  },
  {
    path: '/dietdurationprice/details',
    name: 'adddietdurationprice',
    component: () => import('@/views/menu/diet/dietdurationpricedetails.vue'),
    meta: {
      pageTitle: 'ایجاد قیمت رژیم',
      action: 'show',
      resource: 'DietDurationPriceManager',
    },
  },
  {
    path: '/dietdurationprice/details/:id',
    name: 'updatedietdurationprice',
    component: () => import('@/views/menu/diet/dietdurationpricedetails.vue'),
    meta: {
      pageTitle: 'ویرایش قیمت رژیم',
      action: 'show',
      resource: 'DietDurationPriceManager',
    },
  },
  {
    path: '/alternative-calorie',
    name: 'alternativeCalorie',
    component: () => import('@/views/menu/diet/alternative-calories.vue'),
    meta: {
      pageTitle: 'مدیریت کالری های جایگزین فستینگ',
      action: 'show',
      resource: 'DietDurationPriceManager',
    },
  },
  {
    path: '/evaluation-message',
    name: 'evaluationMessages',
    component: () => import('@/views/menu/evaluationMessage/evaluationMessages.vue'),
    meta: {
      pageTitle: 'مدیریت پیام های ارزشیابی',
      action: 'show',
      resource: 'DietDurationPriceManager',
    },
  },
]
